import React from 'react';
import HelpButton from '../../../../components/HelpButton';
import ErrorBoundary from '../../../../components/ErrorBoundary';
import PbxVbox from './PbxSettings';

const PbxVboxNotifications = React.lazy(() =>
  import('../../Vbox/PbxVboxNotifications')
);
const ArchivedMessagesNotificationsPage = (props) => (
  <PbxVbox>
    <div className="text-right">
      <HelpButton fileName="notifications-fax" />
    </div>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <PbxVboxNotifications {...props} />
      </React.Suspense>
    </ErrorBoundary>
  </PbxVbox>
);

export default ArchivedMessagesNotificationsPage;
